$(document).ready(
    function () {

        $(document).on("click", ".delete-event-image", function () {

            let event_id = $("body").attr("event_id");
            let confirm_message = $(this).data("confirm-message");

            if (!confirm(confirm_message)) {
                return false;
            }

            $.ajax({
                type: 'POST',
                url: "/ajax/organizer_event/delete_image",
                data: {
                    event_id: event_id
                }
            })
                .done(function (data) {

                    if (data.message !== undefined && data.message !== null) {
                        popupAlert();
                        $('#event_register_form .event-image-preview-link, #event_register_form .delete-event-image').remove();
                    }

                })
                .fail(function (data) {

                    if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                        document.location.href = data.responseJSON.redirect_url;
                    }

                });

            return false;

        });

    }
);